import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ReactSession } from "../../../lib/secure_reactsession";
import { LayoutResearcher } from "../../themes/userq/Layouts/layout_researcher";
import { useState, useEffect, useRef } from "react";
import {
    getResearcherTestResultData,
    getPrototypeTestResultData,
    getScreenRecordingData,
    getScreenRecordingVideo,
} from "../../../services/researcher_test_results";
import toast from "react-hot-toast";
import moment from "moment";
import { useRecoilState } from "recoil";
import { testResultAtomFamily, testProjectAtomFamily } from "../../../store/testResultAtoms";
import { roundNumber } from "../../../lib/helpers";
import { LoadingIcon } from "../../loader/loadingIcon";
import { TestResultsHeader } from "../../themes/userq/TestResultsHeader/TestResultsHeader";
import { TestResultsSidebarNavigation } from "./components/test_results_sidebar_navigation";
import { Icon } from "../../themes/userq/Icon/Icon";
import { Text } from "../../themes/userq/Text/Text";
import { PrototypeDropdown } from "../../themes/userq/QuestionsDropdown/PrototypeDropdown";
import { RadioButton } from "../../themes/userq/RadioButton/RadioButton";
import { DropdownComponent } from "../../themes/userq/Dropdown/Dropdown";
import h337 from "heatmap.js";
import PrototypeTestFollowupQuestionsResult from "./prototype-test-followup-questions-results";
import { Button } from "../../themes/userq/Button/Button";
import html2canvas from "html2canvas";
import { ToastMessage } from "../../themes/userq/ToastMessage/ToastMessage";
import { Helmet } from "react-helmet";
import { SearchDropdown } from "../../themes/userq/SearchDropdown/SearchDropdown";
import { Preview } from "../../themes/userq/Preview/preview";
import { Link as UQLink } from "../../themes/userq/Link/Link";
import ScreenRecordingTable from "./components/screen_recording_table";
import BaseModal from "../../themes/userq/Modal/BaseModal";
import VideoPlayer from "../../themes/userq/VideoPlayer/video_player";
import InnerNavigationTab from "../../themes/userq/InnernavigationTab/innerNavigationTab";

export function compare(a, b) {
    const value1 = a[1]["averageranking"];
    const value2 = b[1]["averageranking"];

    let comparison = 0;

    if (value1 > value2) {
        comparison = -1;
    } else if (value1 < value2) {
        comparison = 1;
    }
    return comparison;
}

export default function TestResultPrototypeTest({ isSharedLink }) {
    let { test_id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const exportImageRef = useRef();
    const exportHeatmapRef = useRef();
    const exportClickmapRef = useRef();
    const exportRef = useRef();

    const imageHeatmapRef = useRef();
    const imageClickmapRef = useRef();

    const refs = useRef([]);

    const [focusScroll, setFocusScroll] = useState("");
    const [focusScrollChange, setFocusScrollChange] = useState("");
    const [isFetchingData, setFetchingData] = useState(false);
    const [isRecordingTableSorting, setRecordingTableSorting] = useState(false);

    const handleScroll = (direction, ele, index) => {
        const scrollAmount = 200;

        const container = ele;
        if (direction === "left") {
            container.scrollLeft -= scrollAmount;
        } else if (direction === "right") {
            container.scrollLeft += scrollAmount;
        }

        setFocusScroll(index);
        setFocusScrollChange(Date.now().toString(36));
    };

    const ScrollFirstTimeOnly = (ele, index) => {
        if (ReactSession.get("handleScroll")) {
            if (ele) {
                handleScroll("left", ele, index);

                ReactSession.set("handleScroll", false);
            }
        }
    };

    useEffect(() => {
        setRefsUpdateCount(refsUpdateCount + 1);
    }, [refs.current]);
    useEffect(() => {
        if (refs.current[focusScroll]) {
        }
    }, [focusScroll, focusScrollChange]);

    const [isLoading, setLoading] = useState(false);
    const [sectionLoading, setSectionLoading] = useState(false);
    const [test, setTest] = useRecoilState(testResultAtomFamily(test_id));
    const [taskArray, setTaskArray] = useState([]);
    const [prototypeDataArray, setPrototypeDataArray] = useState([]);
    const [activePrototypeDataArray, setActivePrototypeDataArray] = useState("");
    const [taskSetting, setTaskSetting] = useState("");
    const [, setActive] = useState(0);
    const [isActiveTask, setActiveTask] = useState(0);
    const [, setDropdownQuestions] = useState(false);
    const [behaviorType, setBehaviorType] = useState("image");
    const [screenOption, setScreenOption] = useState([]);
    const [screenSizes] = useState([
        {
            value: "Fit to width",
            label: "Fit to width",
        },
        {
            value: "Actual size",
            label: "Actual size",
        },
        {
            value: "Fit to canvas",
            label: "Fit to canvas",
        },
    ]);
    const [activeScreenOption, setActiveScreenOption] = useState("");
    const [activeScreenOptionArray, setActiveScreenOptionArray] = useState([]);
    const [activeScreenSize, setActiveScreenSize] = useState("Fit to width");
    const [activeScreenOptionVal, setActiveScreenOptionVal] = useState("");

    const [activeScreenWidth, setActiveScreenWidth] = useState("1000");
    const [activeScreenHeight, setActiveScreenHeight] = useState("1000");

    const [heatmapImageLoading, setHeatmapImageLoading] = useState(false);

    const [, setBaseSixtyFourImage] = useState("");
    const [, setSearch] = useState("");

    const [resultCount, SetResultCount] = useState(0);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [activeTaskMenu, setActiveTaskMenu] = useState("overview");
    const [refsUpdateCount, setRefsUpdateCount] = useState(0);
    const [progressDowloadingMessage, setProgressDowloadingMessage] =
        useState(false);
    const [dowloadingFailedMessage, setDowloadingFailedMessage] = useState(false);
    const [show_support_panel, setShowSupportPanel] = useState(false);

    const [project, setProject] = useRecoilState(testProjectAtomFamily(test_id));

    const [previewModal, setPreviewModal] = useState({
        open: false,
        img: null,
        loading: false,
    });
    const [videoModal, setVideoModal] = useState({
        open: false,
        isloading: false,
    });
    const [sortValue, setSortValue] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [filterOs, setFilterOs] = useState("empty");
    const [filterPath, setFilterPath] = useState("empty");
    const [screenRecordingData, setScreenRecordingData] = useState([]);
    const [isScreenRecordingEnabled, SetIsScreenRecordingEnabled] =
        useState(false);
    const [activeVideoUrl, setActiveVideoUrl] = useState(
        "https://dl12.webmfiles.org/elephants-dream.webm"
    );
    const [activePage, setActivePage] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);
    const [moreDataAvailable, setMoreDataAvailable] = useState(false);
    const [modalData, SetModalData] = useState({});

    const handleVideoModal = (data) => {
        setVideoModal({ open: true, isloading: true });
        getModalVideo(data.test_result_video.id);
        SetModalData(data);
    };
    const handlePagination = () => {
        setActivePage((prev) => prev + 1);
        setLoadingMore(true);
    };
    const getModalVideo = (videoId) => {
        let token = ReactSession.get("token");

        let guest_result_token = "";
        if (location.pathname.substr(1, 1) === "v") {
            guest_result_token = ReactSession.get("guest_result_token");
        }

        let admin_result_token = "";
        if (location.pathname.substr(1, 1) === "a") {
            admin_result_token = ReactSession.get("admin_result_token");
        }
        const formData = {
            id: videoId,
            guest_result_token: guest_result_token,
            admin_result_token: admin_result_token,
        };
        getScreenRecordingVideo(formData, token)
            .then((response) => {
                if (response.type == "blob") {
                    setActiveVideoUrl(response.url);
                    setVideoModal({ open: true, isloading: false });
                } else {
                    toast(
                        <div className="toastinner">
                            {response.message}
                            <a onClick={() => toast.dismiss()}>&times;</a>
                        </div>,
                        {
                            className: "errortoast",
                            position: "bottom-center",
                            duration: 2000,
                        }
                    );
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                toast(
                    <div className="toastinner">
                        Something went wrong. Please try again later.
                        <a onClick={() => toast.dismiss()}>&times;</a>
                    </div>,
                    {
                        className: "errortoast",
                        position: "bottom-center",
                        duration: 2000,
                    }
                );
            });
    };
    const handleSort = (value) => {
        if (sortValue === value) {
            setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
        } else {
            setSortOrder("asc"); // Default to 'asc' for a new value
            setSortValue(value);
        }
        setActivePage(1);

        setRecordingTableSorting(true);
    };
    const handleFilterOs = (filterValue) => {
        setFilterOs(filterValue);
        setActivePage(1);
    };
    const handleFilterPath = (filterValue) => {
        setFilterPath(filterValue);

        setActivePage(1);
    };

    const getTestafterEndTest = () => {
        let token = ReactSession.get("token");

        getResearcherTestResultData(
            { test_id: test_id, guest_result_token: "" },
            token
        ).then((response) => {
            setLoading(false);

            if (response.success) {
                setTest(response.test);
            } else {
                navigate("/dashboard");
                toast(
                    <div className="toastinner">
                        {response.message}
                        <a
                            onClick={() => {
                                toast.dismiss();
                            }}
                        >
                            &times;
                        </a>
                    </div>,
                    {
                        className: response.success ? "successtoast" : "errortoast",
                        position: "bottom-center",
                        duration: 2000,
                    }
                );
            }
        });
    };
    const getTest = () => {
        if (!test) {
            let token = ReactSession.get("token");

            setLoading(true);

            let guest_result_token = "";
            if (location.pathname.substr(1, 1) === "v") {
                if (!ReactSession.get("guest_result_token")) {
                    const randomToken = Math.random().toString(36).substr(2, 15);
                    ReactSession.set("guest_result_token", randomToken);
                }

                guest_result_token = ReactSession.get("guest_result_token");
            }
            let admin_result_token = "";
            if (location.pathname.substr(1, 1) === "a") {
                if (!ReactSession.get("admin_result_token")) {
                    const randomToken = Math.random().toString(36).substr(2, 15);
                    ReactSession.set("admin_result_token", randomToken);
                }

                admin_result_token = ReactSession.get("admin_result_token");
            }

            getResearcherTestResultData(
                {
                    test_id: test_id,
                    guest_result_token: guest_result_token,
                    admin_result_token: admin_result_token,
                },
                token
            ).then((response) => {
                setLoading(false);

                if (response.success) {
                    if (response.workspace_project_team_member) {
                        if (response.workspace_project_team_member.status != "active") {
                            navigate(
                                "/wsp/" +
                                response.workspace_project_team_member.workspace_id +
                                "/p/" +
                                response.workspace_project_team_member.workspace_project_id +
                                "/project-no-access"
                            );
                        }
                    }
                    if (response.test && response.test.workspace_project) {
                        setProject(response.test.workspace_project);
                    }
                    if (
                        location.pathname.substr(1, 1) === "v" &&
                        response.is_share_result
                    ) {
                        navigate(`/v/results/${test_id}/results-not-available`);
                    }

                    if (
                        location.pathname.substr(1, 1) === "v" &&
                        response.test.password &&
                        !response.test_password_verify
                    ) {
                        navigate(`/v/results/${test_id}/password`);
                    }

                    setTest(response.test);
                    getPrototypeTest();
                } else {
                    if (response.message == "Project not found.") {
                        navigate("/404");
                    } else if (response.message == "Test Record Not found") {
                        navigate("/404");
                    } else {
                        if (location.pathname.substr(1, 1) === "v") {
                            if (
                                response.test_shared_results &&
                                !response.test_password_verify
                            ) {
                                return navigate(`/v/results/${test_id}/password`);
                            } else if (!response.test_shared_results) {
                                return navigate(`/v/results/${test_id}/results-not-available`);
                            }
                        }
                        if (location.pathname.substr(1, 1) === "a") {
                            if (!response.test_results_available) {
                                return navigate(`/v/results/${test_id}/results-not-available`);
                            }
                        }
                        toast(
                            <div className="toastinner">
                                {response.message}
                                <a
                                    onClick={() => {
                                        toast.dismiss();
                                    }}
                                >
                                    &times;
                                </a>
                            </div>,
                            {
                                className: response.success ? "successtoast" : "errortoast",
                                position: "bottom-center",
                                duration: 2000,
                            }
                        );
                    }
                }
            });
        } else {
            getPrototypeTest();
        }
    };

    const getPrototypeTest = () => {
        let token = ReactSession.get("token");

        setSectionLoading(true);

        let guest_result_token = "";
        if (location.pathname.substr(1, 1) === "v") {
            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";
        if (location.pathname.substr(1, 1) === "a") {
            admin_result_token = ReactSession.get("admin_result_token");
        }

        getPrototypeTestResultData(
            {
                test_id: test_id,
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
            },
            token
        ).then((response) => {
            setSectionLoading(false);

            if (response.success) {
                setTaskArray(response.test.prototype_test_tasks);
                setTaskSetting(response.test.prototype_test_setting);
                setPrototypeDataArray(response.data);
                changeActiveTask(1, response.data);
                SetResultCount(response.resultcount);

                if (!response.some_nodes_failed) {
                    setProgressDowloadingMessage(response.some_nodes_downloading);
                }
                let prototype_download_failed_messages = ReactSession.get(
                    "prototype_download_failed_messages"
                ) || { test_id: false };

                if (!prototype_download_failed_messages[test_id]) {
                    setDowloadingFailedMessage(response.some_nodes_failed);
                }
            } else {
                toast(
                    <div className="toastinner">
                        {response.message}
                        <a
                            onClick={() => {
                                toast.dismiss();
                            }}
                        >
                            &times;
                        </a>
                    </div>,
                    {
                        className: response.success ? "successtoast" : "errortoast",
                        position: "bottom-center",
                        duration: 2000,
                    }
                );
            }
        });
    };

    useEffect(() => {
        getTest();
    }, [location]);

    const callbackTopbar = (data) => {
        getTest();
        getTestafterEndTest();
    };

    useEffect(() => {
        if (isActiveTask in prototypeDataArray) {
            var dataAnswer = prototypeDataArray[isActiveTask];
            var screenOptionArray = [];
            dataAnswer.behaviourData.forEach((items) => {
                screenOptionArray.push({
                    label: items.name,
                    value: items.name,
                    prefix_label:
                        items.contributedheatMapUsers > 0 && behaviorType != "image" ? (
                            <>
                                <Icon value={"user"} colorClass={"gray-700-svg"} />
                                {items.contributedheatMapUsers}
                            </>
                        ) : (
                            <></>
                        ),
                    node_id: items.node_id,
                    img: items.img,
                    is_placeholder: items.is_placeholder,
                });
            });
            setFocusScrollChange(Date.now().toString(36));

            setActiveScreenOptionArray(screenOptionArray);
            if (screenOptionArray.length > 0) {
                setScreenOption(screenOptionArray);
            }
        }
    }, [behaviorType]);

    const changeActiveTask = (index, data) => {
        setActive(index);
        setActiveTask(index - 1); // set active task
        setDropdownQuestions(false); // hide dropdown value
        setSearch(""); // hide dropdown value

        setFilterOs("empty");

        setFilterPath("empty");

        setActivePage(1);

        const dataAnswer = data.find((item, indexItem) => indexItem + 1 === index);
        if (dataAnswer) {
            setActivePrototypeDataArray(dataAnswer);
            setBehaviorType("image");

            var screenOptionArray = [];
            dataAnswer.behaviourData.forEach((items) => {
                screenOptionArray.push({
                    label: items.name,
                    value: items.name,
                    prefix_label: <></>,
                    node_id: items.node_id,
                    img: items.img,
                    is_placeholder: items.is_placeholder,
                });
            });
            setFocusScrollChange(Date.now().toString(36));

            setActiveScreenOptionArray(screenOptionArray);
            if (screenOptionArray.length > 0) {
                setActiveScreenOption(screenOptionArray[0].node_id);
                setActiveScreenOptionVal(screenOptionArray[0].label);
                setScreenOption(screenOptionArray);
            }

            ReactSession.set("handleScroll", "active");
        }
    };

    useEffect(() => {
        setTimeout(() => {
            var is_calculation = false;

            if (
                activePrototypeDataArray &&
                activePrototypeDataArray.behaviourData &&
                Array.isArray(activePrototypeDataArray.behaviourData)
            ) {
                activePrototypeDataArray.behaviourData.forEach(function (item) {
                    if (item.node_id == activeScreenOption) {
                        if (item.is_placeholder == "no") {
                            is_calculation = true;
                        }
                    }
                });
                if (is_calculation) {
                    HeatmapCalculations(activePrototypeDataArray.behaviourData);
                }
            }
        }, 500);
    }, [activeScreenOption, behaviorType]);

    const HeatmapCalculations = (dataItems) => {
        document.querySelectorAll(".heatmap-canvas").forEach((el) => el.remove());

        var heatmapInstance = null;
        var clickmapInstance = null;

        if (behaviorType === "heatmap") {
            if (!imageHeatmapRef.current) {
                console.error(
                    "imageHeatmapRef.current is not available in HeatmapCalculations"
                );
                setHeatmapImageLoading(false);
                return;
            }
            setActiveScreenWidth(imageHeatmapRef.current.clientWidth);
            setActiveScreenHeight(imageHeatmapRef.current.clientHeight);
        } else if (behaviorType === "clickmap") {
            if (!imageClickmapRef.current) {
                console.error(
                    "imageClickmapRef.current is not available in HeatmapCalculations"
                );
                setHeatmapImageLoading(false);
                return;
            }
            setActiveScreenWidth(imageClickmapRef.current.clientWidth);
            setActiveScreenHeight(imageClickmapRef.current.clientHeight);
        }

        if (behaviorType === "heatmap") {
            if (!imageHeatmapRef.current) {
                console.error(
                    "imageHeatmapRef.current is not available for heatmap creation"
                );
                setHeatmapImageLoading(false);
                return;
            }

            const heatmapContainer = document.querySelector(".heatmapImage");
            if (!heatmapContainer) {
                console.error(".heatmapImage container not found");
                setHeatmapImageLoading(false);
                return;
            }

            heatmapInstance = h337.create({
                container: heatmapContainer,
                width: imageHeatmapRef.current.clientWidth,
                height: imageHeatmapRef.current.clientHeight,
                gradient: {
                    ".5": "#9759CB",
                    ".8": "#FFB800",
                    ".9": "#e6542a",
                },
            });

            const points = [];
            const max = 0;
            dataItems.forEach((items) => {
                if (items.node_id === activeScreenOption) {
                    items.heatMapDataArray.forEach((heat) => {
                        const point = {
                            x: heat.x,
                            y: heat.y,
                            value: heat.value,
                        };
                        points.push(point);
                    });
                }
            });
            const data = {
                max: max,
                data: points,
            };
            heatmapInstance.setData(data);
        }

        if (behaviorType === "clickmap") {
            if (!imageClickmapRef.current) {
                console.error(
                    "imageClickmapRef.current is not available for clickmap creation"
                );
                setHeatmapImageLoading(false);
                return;
            }

            const clickmapContainer = document.querySelector(".clickMapImage");
            if (!clickmapContainer) {
                console.error(".clickMapImage container not found");
                setHeatmapImageLoading(false);
                return;
            }

            clickmapInstance = h337.create({
                container: clickmapContainer,
                radius: 5,
                maxOpacity: 1,
                minOpacity: 0,
                blur: 0,
                width: imageClickmapRef.current.clientWidth,
                height: imageClickmapRef.current.clientHeight,
                gradient: {
                    ".95": "#E32F83",
                },
            });

            const points = [];
            const max = 0;

            dataItems.forEach((items) => {
                if (items.node_id === activeScreenOption) {
                    items.heatMapDataArray.forEach((heat) => {
                        const point = {
                            x: heat.x,
                            y: heat.y,
                            value: heat.value,
                        };
                        points.push(point);
                    });
                }
            });

            const data = {
                max: max,
                data: points,
            };
            clickmapInstance.setData(data);
        }

        if (behaviorType === "heatmap") {
            if (!imageHeatmapRef.current) {
                console.error("imageHeatmapRef.current is not available");
                setHeatmapImageLoading(false);
                return;
            }

            if (!imageHeatmapRef.current.src) {
                console.error("imageHeatmapRef.current.src is not available");
                setHeatmapImageLoading(false);
                return;
            }

            setHeatmapImageLoading(true);

            const imageUrl =
                process.env.REACT_APP_API_END_POINT +
                "prototype-test-node-image?image=" +
                imageHeatmapRef.current.src;

            convertImageToBase64(
                imageUrl,
                function (data) {
                    if (!imageHeatmapRef.current) {
                        console.error(
                            "imageHeatmapRef.current is not available in callback"
                        );
                        setHeatmapImageLoading(false);
                        return;
                    }

                    if (!heatmapInstance) {
                        console.error("heatmapInstance is not available in callback");
                        setHeatmapImageLoading(false);
                        return;
                    }

                    const imageData = data;
                    const heatmapDataUrl = heatmapInstance.getDataURL();
                    const imgWidth = imageHeatmapRef.current.clientWidth;
                    const imgHeight = imageHeatmapRef.current.clientHeight;

                    setHeatmapImageLoading(false);

                    function waitForCanvas(maxAttempts = 100, attempt = 0) {
                        const canvas =
                            exportRef.current || document.getElementById("my-canvas");
                        if (canvas && canvas.getContext) {
                            drawImages(imageData, heatmapDataUrl, imgWidth, imgHeight);
                        } else if (attempt < maxAttempts) {
                            if (attempt % 10 === 0) {
                                setTimeout(() => {
                                    waitForCanvas(maxAttempts, attempt + 1);
                                }, 100);
                            } else {
                                requestAnimationFrame(() => {
                                    waitForCanvas(maxAttempts, attempt + 1);
                                });
                            }
                        } else {
                            console.error(
                                'Canvas element "my-canvas" not found after multiple attempts'
                            );
                            console.error("Attempted to find canvas:", {
                                exportRef: exportRef.current,
                                getElementById: document.getElementById("my-canvas"),
                                behaviorType: behaviorType,
                                attempt: attempt,
                                heatmapImageLoading: heatmapImageLoading,
                            });
                        }
                    }

                    function drawImages(imageData, heatmapDataUrl, imgWidth, imgHeight) {
                        const imgs = [
                            {
                                uri: imageData,
                                x: 0,
                                y: 0,
                                sw: imgWidth,
                                sh: imgHeight,
                                type: "image",
                            },
                            {
                                uri: heatmapDataUrl,
                                x: 0,
                                y: 0,
                                sw: imgWidth,
                                sh: imgHeight,
                                type: "heatmap",
                            },
                        ];

                        Promise.all(imgs.map(depict))
                            .then(() => { })
                            .catch((error) => {
                                console.error("Error drawing images:", error);
                            });
                    }

                    setTimeout(() => {
                        waitForCanvas();
                    }, 0);

                    const canvasWrapper = document.getElementById(
                        "heatmap-clickmap-canvas-wrapper"
                    );
                    if (canvasWrapper) {
                        canvasWrapper.scrollIntoView({
                            behavior: "smooth",
                            block: "top",
                        });
                    }
                },
                function (error) {
                    console.error("Heatmap image conversion failed:", error);
                    setHeatmapImageLoading(false);
                }
            );
        }

        if (behaviorType === "clickmap") {
            if (!imageClickmapRef.current) {
                console.error("imageClickmapRef.current is not available");
                setHeatmapImageLoading(false);
                return;
            }

            if (!imageClickmapRef.current.src) {
                console.error("imageClickmapRef.current.src is not available");
                setHeatmapImageLoading(false);
                return;
            }

            setHeatmapImageLoading(true);

            const imageUrl =
                process.env.REACT_APP_API_END_POINT +
                "prototype-test-node-image?image=" +
                imageClickmapRef.current.src;

            convertImageToBase64(
                imageUrl,
                function (data) {
                    if (!imageClickmapRef.current) {
                        console.error(
                            "imageClickmapRef.current is not available in callback"
                        );
                        setHeatmapImageLoading(false);
                        return;
                    }

                    if (!clickmapInstance) {
                        console.error("clickmapInstance is not available in callback");
                        setHeatmapImageLoading(false);
                        return;
                    }

                    const imageData = data;
                    const clickmapDataUrl = clickmapInstance.getDataURL();
                    const imgWidth = imageClickmapRef.current.clientWidth;
                    const imgHeight = imageClickmapRef.current.clientHeight;

                    setHeatmapImageLoading(false);

                    function waitForCanvas(maxAttempts = 100, attempt = 0) {
                        const canvas =
                            exportRef.current || document.getElementById("my-canvas");
                        if (canvas && canvas.getContext) {
                            drawImages(imageData, clickmapDataUrl, imgWidth, imgHeight);
                        } else if (attempt < maxAttempts) {
                            if (attempt % 10 === 0) {
                                setTimeout(() => {
                                    waitForCanvas(maxAttempts, attempt + 1);
                                }, 100);
                            } else {
                                requestAnimationFrame(() => {
                                    waitForCanvas(maxAttempts, attempt + 1);
                                });
                            }
                        } else {
                            console.error(
                                'Canvas element "my-canvas" not found after multiple attempts'
                            );
                            console.error("Attempted to find canvas:", {
                                exportRef: exportRef.current,
                                getElementById: document.getElementById("my-canvas"),
                                behaviorType: behaviorType,
                                attempt: attempt,
                                heatmapImageLoading: heatmapImageLoading,
                            });
                        }
                    }

                    function drawImages(imageData, clickmapDataUrl, imgWidth, imgHeight) {
                        const imgs = [
                            {
                                uri: imageData,
                                x: 0,
                                y: 0,
                                sw: imgWidth,
                                sh: imgHeight,
                                type: "image",
                            },
                            {
                                uri: clickmapDataUrl,
                                x: 0,
                                y: 0,
                                sw: imgWidth,
                                sh: imgHeight,
                                type: "heatmap",
                            },
                        ];

                        Promise.all(imgs.map(depict))
                            .then(() => { })
                            .catch((error) => {
                                console.error("Error drawing images:", error);
                            });
                    }

                    setTimeout(() => {
                        waitForCanvas();
                    }, 0);

                    const canvasWrapper = document.getElementById(
                        "heatmap-clickmap-canvas-wrapper"
                    );
                    if (canvasWrapper) {
                        canvasWrapper.scrollIntoView({
                            behavior: "smooth",
                            block: "top",
                        });
                    }
                },
                function (error) {
                    console.error("Clickmap image conversion failed:", error);
                    setHeatmapImageLoading(false);
                }
            );
        }
    };

    const getContext = () => {
        const canvas = exportRef.current || document.getElementById("my-canvas");
        if (!canvas) {
            console.error('Canvas element with id "my-canvas" not found');
            return null;
        }
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            console.error("Could not get 2d context from canvas");
            return null;
        }
        return ctx;
    };

    const loadImage = (url, type) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error(`load ${url} ${type} fail`));
            img.src = url;
            if (type === "image") {
            }
        });
    };

    const depict = (options) => {
        const ctx = getContext();
        if (!ctx) {
            console.error("Cannot get canvas context in depict function");
            return Promise.reject(new Error("Canvas context not available"));
        }
        const myOptions = Object.assign({}, options);
        return loadImage(myOptions.uri, myOptions.type)
            .then((img) => {
                if (!ctx) {
                    console.error("Canvas context lost during image load");
                    return;
                }
                ctx.drawImage(
                    img,
                    myOptions.x,
                    myOptions.y,
                    myOptions.sw,
                    myOptions.sh
                );
            })
            .catch((error) => {
                console.error("Error in depict function:", error);
                throw error;
            });
    };

    const calculateTime = (time) => {
        var m = Math.floor((time % 3600) / 60);
        var s = Math.floor(time % 60);

        if (m > 0) {
            return `${m}min ${s}sec`;
        } else if (s > 0) {
            return ` ${s}sec`;
        } else {
            return "-";
        }
    };

    const averageTaskTime = (timeSpend) => {
        var averageTimeSpendMinute = Math.floor(timeSpend / (resultCount * 60));
        var averageTimeSpendSeconds = ((timeSpend / resultCount) % 60).toFixed(0);

        if (averageTimeSpendSeconds.length === 1) {
            return averageTimeSpendMinute + "m 0" + averageTimeSpendSeconds + "s";
        } else {
            return averageTimeSpendMinute + "m " + averageTimeSpendSeconds + "s";
        }
    };

    const convertImageToBase64 = (imgUrl, callback, errorCallback) => {
        const image = new Image();
        image.crossOrigin = "anonymous";

        image.onload = () => {
            try {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.height = image.naturalHeight;
                canvas.width = image.naturalWidth;
                ctx.drawImage(image, 0, 0);
                const dataUrl = canvas.toDataURL();
                callback && callback(dataUrl);
                setBaseSixtyFourImage(dataUrl);
            } catch (error) {
                console.error("Error converting image to base64:", error);
                if (errorCallback) {
                    errorCallback(error);
                }
            }
        };

        image.onerror = (error) => {
            console.error("Error loading image:", error, "URL:", imgUrl);
            if (errorCallback) {
                errorCallback(error);
            }
        };

        image.src = imgUrl;
    };

    const checkIfDownloadDisabled = () => {
        var is_calculation = false;

        if (
            activePrototypeDataArray &&
            activePrototypeDataArray.behaviourData &&
            Array.isArray(activePrototypeDataArray.behaviourData)
        ) {
            activePrototypeDataArray.behaviourData.forEach(function (item) {
                if (item.node_id == activeScreenOption) {
                    if (item.is_placeholder == "no") {
                        is_calculation = true;
                    }
                }
            });
        }
        return is_calculation;
    };
    const handleDownload = () => {
        var is_calculation = false;

        if (
            activePrototypeDataArray &&
            activePrototypeDataArray.behaviourData &&
            Array.isArray(activePrototypeDataArray.behaviourData)
        ) {
            activePrototypeDataArray.behaviourData.forEach(function (item) {
                if (item.node_id == activeScreenOption) {
                    if (item.is_placeholder == "no") {
                        is_calculation = true;
                    }
                }
            });
        }
        if (is_calculation) {
            html2canvas(exportRef.current, {
                allowTaint: true,
            }).then((canvas) => {
                const link = document.createElement("a");
                if (behaviorType === "heatmap") {
                    link.download = "heatmap.png";
                } else {
                    link.download = "clickmap.png";
                }

                link.href = canvas.toDataURL("image/png");
                link.click();
            });
        } /*else {
            showToast("The image is not available to download. Please try again later.", "error");
        }*/
    };

    const getRecordingData = () => {
        if (!test_id || !taskArray[isActiveTask]) {
            return;
        }
        let token = ReactSession.get("token");

        let guest_result_token = "";
        if (location.pathname.substr(1, 1) === "v") {
            guest_result_token = ReactSession.get("guest_result_token");
        }

        let admin_result_token = "";
        if (location.pathname.substr(1, 1) === "a") {
            admin_result_token = ReactSession.get("admin_result_token");
        }

        if (activePage !== 1) {
            setFetchingData(false);
        } else {
            if (isRecordingTableSorting) {
                setFetchingData(false);
            } else {
                setFetchingData(true);
            }
        }

        const osobject = { 1: "windows", 2: "mac", 3: "linux" };

        const formData = {
            test_id: taskArray[isActiveTask].test_id,
            page: activePage,
            sort_column: sortValue,
            order_by: sortOrder,
            task_id: taskArray[isActiveTask].id,
            platform: filterOs == "empty" ? "" : osobject[filterOs],
            path: filterPath == "empty" ? "" : filterPath,
            guest_result_token: guest_result_token,
            admin_result_token: admin_result_token,
        };

        getScreenRecordingData(formData, token)
            .then((response) => {
                if (response.success) {
                    if (response.more_records === true) {
                        setMoreDataAvailable(true);
                    } else {
                        setMoreDataAvailable(false);
                    }
                    setLoadingMore(false);
                    setFetchingData(false);
                    if (activePage !== 1) {
                        setScreenRecordingData(screenRecordingData.concat(response.data));
                    } else {
                        setScreenRecordingData(response.data);
                    }
                } else {
                    toast(
                        <div className="toastinner">
                            {response.message}
                            <a onClick={() => toast.dismiss()}>&times;</a>
                        </div>,
                        {
                            className: "errortoast",
                            position: "bottom-center",
                            duration: 2000,
                        }
                    );
                }
                setRecordingTableSorting(false);
            })
            .catch((error) => {
                console.error("Error:", error);
                toast(
                    <div className="toastinner">
                        Something went wrong. Please try again later.
                        <a onClick={() => toast.dismiss()}>&times;</a>
                    </div>,
                    {
                        className: "errortoast",
                        position: "bottom-center",
                        duration: 2000,
                    }
                );
            });
    };

    useEffect(() => {
        if (test.is_screen_recording_enabled == 1) {
            SetIsScreenRecordingEnabled(true);
            getRecordingData();
        }
    }, [
        taskArray,
        sortValue,
        sortOrder,
        activePage,
        filterOs,
        filterPath,
        isActiveTask,
    ]);

    const [headerHeight, setHeaderHeight] = useState(0);

    const handleHeaderHeight = (height) => {
        setHeaderHeight(height);
    };

    return (
        <LayoutResearcher
            isSharedLink={isSharedLink}
            fixed_header_target={true}
            wrapClass={
                "researcher-test-view-overflow overflow-visible researcher-resultwrap"
            }
            resultHeaderClass={"result-header"}
            skipCheck={false}
            extendedFooter={false}
            activeMenu={""}
            openSupportPanel={show_support_panel}
            hideSupportPanel={() => {
                setShowSupportPanel(false);
            }}
        >
            <Helmet>
                <title>Analyse prototype test | UserQ</title>
            </Helmet>
            {isLoading && (
                <div className="loader_section full-page-loader">
                    <LoadingIcon />
                </div>
            )}

            {!isLoading && test && (
                <div className="three-column-layout two-column-layout">
                    <TestResultsHeader
                        project={project}
                        isSharedLink={isSharedLink}
                        test={test}
                        endedOn={
                            test.status === "completed"
                                ? moment.utc(test.ended_on).format("DD-MM-Y")
                                : ""
                        }
                        callbackTopbar={callbackTopbar}
                    />
                    <div className="three-column-layout-body">
                        <div className="three-column-layout-left">
                            <TestResultsSidebarNavigation
                                isSharedLink={isSharedLink}
                                methodology={
                                    test.methodology === "Five Seconds Test"
                                        ? "5 second test"
                                        : test.methodology
                                }
                                selected_index={4}
                                test_id={
                                    location.pathname.substr(1, 1) === "v" ? test_id : test.id
                                }
                                screening={
                                    test &&
                                        test.screening_questions &&
                                        test.screening_questions.length > 0
                                        ? "Yes"
                                        : "No"
                                }
                            />
                        </div>
                        <div className="two-column-right-side">
                            {sectionLoading && (
                                <div className="page-loader accountloading-box result-sections-loader">
                                    <LoadingIcon />
                                </div>
                            )}
                            {!sectionLoading && resultCount !== 0 && (
                                <div className="bd-question-view-wrap">
                                    <div className="prototype-results-top-bar prototype-result-space-hold">
                                        <div className="question-result-header question-result-data is-sticky">
                                            <PrototypeDropdown
                                                questionArray={taskArray}
                                                changeActiveQuestionProp={(index) => {
                                                    changeActiveTask(index, prototypeDataArray);
                                                }}
                                                dropdownOpen={(state) => setDropdownOpen(state)}
                                                resultCount={resultCount}
                                                taskSetting={taskSetting && taskSetting.objective}
                                                test={test}
                                                onHeaderHeightChange={handleHeaderHeight}
                                            />

                                            <InnerNavigationTab
                                                type={"tab"}
                                                activeMenu={"overview"}
                                                cssClasses={
                                                    "result-navigation-outer prototype-navigator-active-link result-navigation pt-3"
                                                }
                                                onTabChange={(key) => {
                                                    setActiveTaskMenu(key);
                                                }}
                                                items={[
                                                    {
                                                        key: "overview",
                                                        label: "Overview",
                                                    },
                                                    {
                                                        key: "common-path",
                                                        label: "Common path",
                                                    },
                                                    {
                                                        key: "behavior",
                                                        label: "Behaviour",
                                                    },
                                                    ...(isScreenRecordingEnabled
                                                        ? [
                                                            {
                                                                key: "screen-recordings",
                                                                label: "Screen recordings",
                                                            },
                                                        ]
                                                        : []),
                                                ]}
                                                scrollSpy={true}
                                                scrollSpace={headerHeight}
                                            />
                                        </div>

                                        <div className={`question-result-data   ${dropdownOpen ? "black-overlay" : ""} ${activeTaskMenu == "screen-recordings" ? "d-none" : ""}`}>

                                            {/*Overview start*/}
                                            <div className="prototype-result-overview-wrap">
                                                <div className={`prototype-overview`} id="overview">
                                                    <div className={`prototype-overview-header`}>
                                                        <Text type={"h4"} children={`Overview`} />
                                                    </div>

                                                    <div className={`prototype-overview-content pt-40 pb-40`}>
                                                        <div className={`row`}>
                                                            {taskSetting &&
                                                                taskSetting.objective === "closed" && (
                                                                    <>
                                                                        <div className={`col-lg-3 col-md-6`}>
                                                                            <div className=" prototype-overview-inner-data completion-rate">
                                                                                <Text
                                                                                    type={"body-text-1"}
                                                                                    fontWeight={"medium-font"}
                                                                                    children={"Completion rate"}
                                                                                />
                                                                                <div className={`data-percent d-flex`}>
                                                                                    <Icon
                                                                                        size={"large"}
                                                                                        value={"success"}
                                                                                        colorClass={"success-green-200-svg"}
                                                                                    />
                                                                                    <Text
                                                                                        type={"h3"}
                                                                                        cssClasses={"green-text"}
                                                                                        children={`${roundNumber(
                                                                                            activePrototypeDataArray.completedTaskCountPercentage,
                                                                                            1
                                                                                        )}%`}
                                                                                    />
                                                                                </div>

                                                                                <Text
                                                                                    type={"caption"}
                                                                                    cssClasses={"gray-color"}
                                                                                >
                                                                                    {
                                                                                        activePrototypeDataArray.completedTaskCount
                                                                                    }{" "}
                                                                                    out of {resultCount} have completed
                                                                                    your task
                                                                                </Text>
                                                                            </div>
                                                                        </div>

                                                                        <div className={`col-lg-3 col-md-6`}>
                                                                            <div className=" prototype-overview-inner-data skip-rate">
                                                                                <Text
                                                                                    type={"body-text-1"}
                                                                                    fontWeight={"medium-font"}
                                                                                    children={"Skip rate"}
                                                                                />

                                                                                <div className={`data-percent d-flex`}>
                                                                                    <Icon
                                                                                        size={"large"}
                                                                                        value={"Forward"}
                                                                                        colorClass={"gray-700-svg"}
                                                                                    />
                                                                                    <Text
                                                                                        type={"h3"}
                                                                                        cssClasses={"light-dark-text"}
                                                                                        children={`${roundNumber(
                                                                                            activePrototypeDataArray.skipTaskCountPercentage,
                                                                                            1
                                                                                        )}%`}
                                                                                    />
                                                                                </div>

                                                                                <Text
                                                                                    type={"caption"}
                                                                                    cssClasses={"gray-color"}
                                                                                >
                                                                                    {
                                                                                        activePrototypeDataArray.skipTaskCount
                                                                                    }{" "}
                                                                                    out of {resultCount} have left or
                                                                                    given up on your task
                                                                                </Text>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}

                                                            <div className={`col-lg-3 col-md-6`}>
                                                                <div className=" prototype-overview-inner-data average-time">
                                                                    <Text
                                                                        type={"body-text-1"}
                                                                        fontWeight={"medium-font"}
                                                                        children={"Average time spent"}
                                                                    />

                                                                    <div className={`data-percent d-flex`}>
                                                                        <Icon size={"large"} value={"time"} />
                                                                        <Text
                                                                            type={"h3"}
                                                                            children={`${averageTaskTime(
                                                                                activePrototypeDataArray.prototypeTaskResultsAverageTime
                                                                            )}`}
                                                                        />
                                                                    </div>

                                                                    <Text
                                                                        type={"caption"}
                                                                        cssClasses={"gray-color"}
                                                                    >
                                                                        The average time spent on this task is{" "}
                                                                        {averageTaskTime(
                                                                            activePrototypeDataArray.prototypeTaskResultsAverageTime
                                                                        )}
                                                                    </Text>
                                                                </div>
                                                            </div>

                                                            <div className={`col-lg-3 col-md-6`}>
                                                                <div className=" prototype-overview-inner-data average-click">
                                                                    <Text
                                                                        type={"body-text-1"}
                                                                        fontWeight={"medium-font"}
                                                                        children={"Average clicks"}
                                                                    />

                                                                    <div className={`data-percent d-flex`}>
                                                                        <Icon size={"large"} value={"click"} />
                                                                        <Text
                                                                            type={"h3"}
                                                                            children={Math.ceil(
                                                                                activePrototypeDataArray.average_click
                                                                            )}
                                                                        />
                                                                    </div>

                                                                    <Text
                                                                        type={"caption"}
                                                                        cssClasses={"gray-color"}
                                                                    >
                                                                        The average clicks was{" "}
                                                                        {Math.ceil(
                                                                            activePrototypeDataArray.average_click
                                                                        )}
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*Overview end*/}

                                                {/*Common path start*/}
                                                <div className={`prototype-common-path pb-20`} id={"common-path"}>
                                                    <div className={`common-path-header`}>
                                                        <Text type={"h4"} children={"Common paths"} />
                                                        <Text
                                                            type={"body-text-2"}
                                                            cssClasses={"light-dark-text mt-20"}
                                                            fontWeight={"medium-font"}
                                                            children={
                                                                "A common path is the series of events performed or experienced by the majority of the users"
                                                            }
                                                        />
                                                    </div>

                                                    <div className={`common-path-content`}>
                                                        {progressDowloadingMessage && (
                                                            <div className="fixed-toast-wrapper">
                                                                <ToastMessage
                                                                    type={"info"}
                                                                    closable={false}
                                                                    message={
                                                                        <>
                                                                            Loading the prototype images is taking
                                                                            longer than expected and some of them are
                                                                            not visible in the results.{" "}
                                                                            <UQLink url={location.pathname}>
                                                                                Please refresh the screen
                                                                            </UQLink>
                                                                            .
                                                                        </>
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                        {dowloadingFailedMessage && (
                                                            <div className="fixed-toast-wrapper">
                                                                <ToastMessage
                                                                    type={"error"}
                                                                    closable="true"
                                                                    onClose={() => {
                                                                        let prototype_download_failed_messages =
                                                                            ReactSession.get(
                                                                                "prototype_download_failed_messages"
                                                                            ) || {
                                                                                [test.id]: false,
                                                                            };
                                                                        prototype_download_failed_messages[
                                                                            test.id
                                                                        ] = true;

                                                                        ReactSession.set(
                                                                            "prototype_download_failed_messages",
                                                                            prototype_download_failed_messages
                                                                        );

                                                                        setDowloadingFailedMessage(false);
                                                                    }}
                                                                    message={
                                                                        "We’re unable to load your Figma prototype and some images may not be visible in the results."
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                        {activePrototypeDataArray &&
                                                            activePrototypeDataArray.commonPath.map(
                                                                (items, index) => {
                                                                    return (
                                                                        <React.Fragment key={items.id || `common-path-${index}`}>
                                                                            <div className="prototype-commont-path-repeat" key={index}>
                                                                                <div className="prototype-arrow-hold d-flex align-items-center justify-content-between">
                                                                                    <div className={`prototype-path-info-top d-flex `}>
                                                                                        {taskSetting &&
                                                                                            taskSetting.objective ===
                                                                                            "closed" && (
                                                                                                <>
                                                                                                    <div
                                                                                                        className={`common-path-info-data-repeat d-flex align-items-center success-path`}
                                                                                                    >
                                                                                                        {items.is_success ? (
                                                                                                            <>
                                                                                                                <Icon
                                                                                                                    size={"medium"}
                                                                                                                    value={"success"}
                                                                                                                    colorClass={
                                                                                                                        "success-green-200-svg"
                                                                                                                    }
                                                                                                                />
                                                                                                                <Text
                                                                                                                    type={"body-text-3"}
                                                                                                                    cssClasses="green-text"
                                                                                                                    fontWeight={
                                                                                                                        "medium-font"
                                                                                                                    }
                                                                                                                    children={
                                                                                                                        "Success path"
                                                                                                                    }
                                                                                                                />
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                <Icon
                                                                                                                    size={"medium"}
                                                                                                                    value={"error"}
                                                                                                                    colorClass={
                                                                                                                        "danger-200-svg"
                                                                                                                    }
                                                                                                                />
                                                                                                                <Text
                                                                                                                    type={"body-text-3"}
                                                                                                                    cssClasses="red-text"
                                                                                                                    fontWeight={
                                                                                                                        "medium-font"
                                                                                                                    }
                                                                                                                    children={
                                                                                                                        "Failure path"
                                                                                                                    }
                                                                                                                />
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}

                                                                                        <div
                                                                                            className={`common-path-info-data-repeat d-flex align-items-center average-time none-for-mobile`}
                                                                                        >
                                                                                            <Icon
                                                                                                size={"medium"}
                                                                                                value={"time"}
                                                                                            />
                                                                                            <Text
                                                                                                type={"body-text-3"}
                                                                                                fontWeight={"medium-font"}
                                                                                                children={`Average time spent: ${items.commonPathTravelAverageTime}s`}
                                                                                            />
                                                                                        </div>

                                                                                        <div
                                                                                            className={`common-path-info-data-repeat d-flex align-items-center average-time none-for-desktop`}
                                                                                        >
                                                                                            <Icon
                                                                                                size={"medium"}
                                                                                                value={"time"}
                                                                                            />
                                                                                            <Text
                                                                                                type={"body-text-3"}
                                                                                                fontWeight={"medium-font"}
                                                                                                children={`Ave. time spent: ${items.commonPathTravelAverageTime}s`}
                                                                                            />
                                                                                        </div>

                                                                                        <div
                                                                                            className={`common-path-info-data-repeat d-flex align-items-center participant`}
                                                                                        >
                                                                                            <Icon
                                                                                                size={"medium"}
                                                                                                value={"group"}
                                                                                            />
                                                                                            <Text
                                                                                                type={"body-text-3"}
                                                                                                fontWeight={"medium-font"}
                                                                                                children={`Participants: ${items.total_participants}`}
                                                                                            />
                                                                                        </div>

                                                                                        <div
                                                                                            className={`common-path-info-data-repeat d-flex align-items-center total-screens`}
                                                                                        >
                                                                                            {test.device == "all" && (
                                                                                                <Icon
                                                                                                    value={"desktop-and-phone"}
                                                                                                    size={"medium"}
                                                                                                />
                                                                                            )}
                                                                                            {test.device == "mobile" && (
                                                                                                <Icon
                                                                                                    value={"phone"}
                                                                                                    size={"medium"}
                                                                                                />
                                                                                            )}
                                                                                            {test.device == "desktop" && (
                                                                                                <Icon
                                                                                                    value={"tablet"}
                                                                                                    size="medium"
                                                                                                />
                                                                                            )}
                                                                                            <Text
                                                                                                type={"body-text-3"}
                                                                                                fontWeight={"medium-font"}
                                                                                            >
                                                                                                {`${items.pathTravel.length === 1
                                                                                                    ? "Screen:"
                                                                                                    : "Screens:"
                                                                                                    } ${items.pathTravel.length}`}
                                                                                            </Text>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className={`dropdown-header-arrow-buttons mobile-nav-arrows prototype-arrow none-for-mobile ${refs.current[index] == null ||
                                                                                            (refs.current[index] &&
                                                                                                refs.current[index]
                                                                                                    .scrollLeft === 0 &&
                                                                                                refs.current[index]
                                                                                                    .scrollWidth ===
                                                                                                parseInt(
                                                                                                    refs.current[index]
                                                                                                        .scrollLeft +
                                                                                                    refs.current[index]
                                                                                                        .clientWidth
                                                                                                ))
                                                                                            ? "d-none"
                                                                                            : ""
                                                                                            }`}
                                                                                    >
                                                                                        <div className="bd-que-slide-arrow">
                                                                                            <a
                                                                                                onClick={() => {
                                                                                                    handleScroll(
                                                                                                        "left",
                                                                                                        refs.current[index],
                                                                                                        index
                                                                                                    );
                                                                                                }}
                                                                                                className={`${refs.current[index] &&
                                                                                                    refs.current[index]
                                                                                                        .scrollLeft == 0
                                                                                                    ? "disabled-link"
                                                                                                    : ""
                                                                                                    } dropdown-toggle-disabled`}
                                                                                            >
                                                                                                <Icon
                                                                                                    value="back-arrow"
                                                                                                    size="small"
                                                                                                    colorClass={
                                                                                                        "gray-50-svg dropdown-toggle-disabled"
                                                                                                    }
                                                                                                />
                                                                                            </a>
                                                                                            <a
                                                                                                onClick={() => {
                                                                                                    handleScroll(
                                                                                                        "right",
                                                                                                        refs.current[index],
                                                                                                        index
                                                                                                    );
                                                                                                }}
                                                                                                className={`${refs.current[index] &&
                                                                                                    (refs.current[index]
                                                                                                        .scrollWidth ||
                                                                                                        refs.current[index]
                                                                                                            .scrollWidth - 1) ==
                                                                                                    parseInt(
                                                                                                        refs.current[index]
                                                                                                            .scrollLeft +
                                                                                                        refs.current[index]
                                                                                                            .clientWidth
                                                                                                    )
                                                                                                    ? "disabled-link"
                                                                                                    : ""
                                                                                                    } dropdown-toggle-disabled`}
                                                                                            >
                                                                                                <Icon
                                                                                                    value="forward-arrow"
                                                                                                    size="small"
                                                                                                    colorClass={
                                                                                                        "gray-50-svg dropdown-toggle-disabled"
                                                                                                    }
                                                                                                />
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                    <span className={"d-none"}>
                                                                                        {setTimeout(() => {
                                                                                            ScrollFirstTimeOnly(
                                                                                                refs.current[index],
                                                                                                index
                                                                                            );
                                                                                        }, 1000)}
                                                                                    </span>
                                                                                </div>

                                                                                <div
                                                                                    className={`proto-common-path-row ${test.device == "mobile"
                                                                                        ? "prototype-results-mobile-device"
                                                                                        : ""
                                                                                        }`}
                                                                                    ref={(element) => {
                                                                                        refs.current[index] = element;
                                                                                    }}
                                                                                    onScroll={() =>
                                                                                        handleScroll(
                                                                                            "mouse",
                                                                                            refs.current[index],
                                                                                            index
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {items.pathTravel.map(
                                                                                        (PathItems, indexPath, arr) => {
                                                                                            return (
                                                                                                <div
                                                                                                    className={`common-path-repeat ${items.is_success &&
                                                                                                        arr.length - 1 === indexPath
                                                                                                        ? "is_selected_screen"
                                                                                                        : ""
                                                                                                        }`}
                                                                                                    key={indexPath}
                                                                                                >
                                                                                                    <div className=" common-path-content ">
                                                                                                        <div
                                                                                                            className={`proto-common-path-img-preview ${PathItems.is_placeholder ==
                                                                                                                "no"
                                                                                                                ? "image-preview"
                                                                                                                : ""
                                                                                                                }`}
                                                                                                        >
                                                                                                            {PathItems.is_placeholder ==
                                                                                                                "no" && (
                                                                                                                    <img
                                                                                                                        src={
                                                                                                                            PathItems.img
                                                                                                                                ? process.env
                                                                                                                                    .REACT_APP_IMG_URL +
                                                                                                                                PathItems.img
                                                                                                                                : process.env
                                                                                                                                    .REACT_APP_URL +
                                                                                                                                "img/default-placeholder-node-img.png"
                                                                                                                        }
                                                                                                                    />
                                                                                                                )}
                                                                                                            {PathItems.is_placeholder ==
                                                                                                                "yes" && (
                                                                                                                    <div className="path-preview-not-available">
                                                                                                                        <Icon
                                                                                                                            value={"error"}
                                                                                                                            size={"medium"}
                                                                                                                        />
                                                                                                                        <Text
                                                                                                                            type={"caption"}
                                                                                                                            fontWeight={
                                                                                                                                "medium-font"
                                                                                                                            }
                                                                                                                        >
                                                                                                                            Preview not
                                                                                                                            available
                                                                                                                        </Text>
                                                                                                                    </div>
                                                                                                                )}

                                                                                                            {PathItems.is_placeholder ==
                                                                                                                "no" && (
                                                                                                                    <div className="prototype-preview-btn">
                                                                                                                        <Button
                                                                                                                            type={"primary"}
                                                                                                                            cssclass={
                                                                                                                                "white-bg-btn"
                                                                                                                            }
                                                                                                                            size="small"
                                                                                                                            iconLeft={
                                                                                                                                <Icon
                                                                                                                                    size={"small"}
                                                                                                                                    value={"eye"}
                                                                                                                                    colorClass={
                                                                                                                                        "gray-900-svg"
                                                                                                                                    }
                                                                                                                                />
                                                                                                                            }
                                                                                                                            label={"Preview"}
                                                                                                                            onClick={() => {
                                                                                                                                setPreviewModal({
                                                                                                                                    ...previewModal,
                                                                                                                                    open: true,
                                                                                                                                    img: PathItems.img
                                                                                                                                        ? process.env
                                                                                                                                            .REACT_APP_IMG_URL +
                                                                                                                                        PathItems.img
                                                                                                                                        : process.env
                                                                                                                                            .REACT_APP_URL +
                                                                                                                                        "img/default-placeholder-node-img.png",
                                                                                                                                });
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                )}
                                                                                                        </div>
                                                                                                        <div className="common-path-content-footer">
                                                                                                            <Text
                                                                                                                type={"caption"}
                                                                                                                children={
                                                                                                                    PathItems.name
                                                                                                                }
                                                                                                            />

                                                                                                            <div
                                                                                                                className={`data-time d-flex`}
                                                                                                            >
                                                                                                                <Icon
                                                                                                                    size={"small"}
                                                                                                                    value={"time"}
                                                                                                                />
                                                                                                                <Text
                                                                                                                    cssClasses={
                                                                                                                        "light-dark-text"
                                                                                                                    }
                                                                                                                    type={"caption"}
                                                                                                                    children={`${PathItems.time}s`}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    );
                                                                }
                                                            )}
                                                    </div>
                                                </div>
                                                {/*Common path end*/}

                                                {/*Behaviour start*/}
                                                <div className={`prototype-behavior`} id={"behavior"}>
                                                    <div className={`behavior-header`}>
                                                        <Text type={"h4"} children={"Behaviour"} />
                                                    </div>

                                                    <div className={`prototype-behavior-content mt-40`}>
                                                        <div
                                                            className={`behavior-content-top d-flex justify-content-between`}
                                                        >
                                                            <div
                                                                className={`behavior-top-left-content d-flex`}
                                                            >
                                                                <RadioButton
                                                                    id="open_image_toggle"
                                                                    isChecked={
                                                                        behaviorType === "image" ? true : false
                                                                    }
                                                                    label={
                                                                        <Text
                                                                            display="inline"
                                                                            type="body-text-2"
                                                                            fontWeight={"medium-font"}
                                                                            cssClasses={
                                                                                "d-flex align-items-center radio-tab-icon"
                                                                            }
                                                                        >
                                                                            <Icon
                                                                                value={"image"}
                                                                                colorClass={"gray-700-svg"}
                                                                            />{" "}
                                                                            Image
                                                                        </Text>
                                                                    }
                                                                    onChange={(e) => {
                                                                        setBehaviorType(e.target.value);
                                                                    }}
                                                                    value={"image"}
                                                                />

                                                                <RadioButton
                                                                    id="open_heatmap_toggle"
                                                                    isChecked={
                                                                        behaviorType === "heatmap" ? true : false
                                                                    }
                                                                    label={
                                                                        <Text
                                                                            display="inline"
                                                                            type="body-text-2"
                                                                            fontWeight={"medium-font"}
                                                                            cssClasses={
                                                                                "d-flex align-items-center radio-tab-icon"
                                                                            }
                                                                        >
                                                                            <Icon
                                                                                value={"Heatmap"}
                                                                                colorClass={"gray-700-svg"}
                                                                            />{" "}
                                                                            Heatmap
                                                                        </Text>
                                                                    }
                                                                    onChange={(e) => {
                                                                        setBehaviorType(e.target.value);
                                                                    }}
                                                                    value={"heatmap"}
                                                                />

                                                                <RadioButton
                                                                    id="open_clickmap_toggle"
                                                                    isChecked={
                                                                        behaviorType === "clickmap" ? true : false
                                                                    }
                                                                    label={
                                                                        <Text
                                                                            display="inline"
                                                                            type="body-text-2"
                                                                            fontWeight={"medium-font"}
                                                                            cssClasses={
                                                                                "d-flex align-items-center radio-tab-icon"
                                                                            }
                                                                        >
                                                                            <Icon
                                                                                value={"click"}
                                                                                colorClass={"gray-700-svg"}
                                                                            />{" "}
                                                                            Clickmap
                                                                        </Text>
                                                                    }
                                                                    onChange={(e) => {
                                                                        setBehaviorType(e.target.value);
                                                                    }}
                                                                    value={"clickmap"}
                                                                />
                                                            </div>

                                                            <div className={`behavior-top-right-content d-flex`}>
                                                                <div className={`prototype-behavior-screen-size-content`}>
                                                                    <DropdownComponent
                                                                        name="screenSize"
                                                                        label="Select size"
                                                                        onChange={(data) => {
                                                                            setActiveScreenSize(data.value);
                                                                        }}
                                                                        options={screenSizes}
                                                                        value={activeScreenSize}
                                                                        isClearable={false}
                                                                    />
                                                                </div>

                                                                <SearchDropdown
                                                                    className={"ml-20"}
                                                                    label={"Select screen"}
                                                                    value={activeScreenOptionVal}
                                                                    onChange={(item_new) => {
                                                                        var item = {
                                                                            label: item_new,
                                                                            value: item_new,
                                                                        };
                                                                        var selectItem =
                                                                            activeScreenOptionArray.find(
                                                                                (x) => x.value === item.value
                                                                            );

                                                                        if (selectItem) {
                                                                            setActiveScreenOption(selectItem.node_id);
                                                                        }

                                                                        setActiveScreenOptionVal(item.value);
                                                                    }}
                                                                    options={screenOption}
                                                                />

                                                                {behaviorType !== "image" && (
                                                                    <Button
                                                                        size={"medium"}
                                                                        type={"secondary"}
                                                                        iconLeft={<Icon value={"download"} />}
                                                                        label={"Download Image"}
                                                                        onClick={(e) => {
                                                                            handleDownload();
                                                                        }}
                                                                        state={
                                                                            !checkIfDownloadDisabled()
                                                                                ? "disabled"
                                                                                : ""
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div
                                                            className={`behavior-main-slider-content-none  dropdown-header-arrow-buttons
                                                                ${behaviorType ===
                                                                    "image"
                                                                    ? ""
                                                                    : "heatmap-clickmap-data-none prototype-map-slider-wrap"
                                                                }`}
                                                        >
                                                            {activePrototypeDataArray.behaviourData &&
                                                                activePrototypeDataArray.behaviourData.map(
                                                                    (items, index) => {
                                                                        return (
                                                                            <React.Fragment
                                                                                key={
                                                                                    items.node_id || `behaviour-${index}`
                                                                                }
                                                                            >
                                                                                {items.node_id ===
                                                                                    activeScreenOption && (
                                                                                        <>
                                                                                            <div className="w-100 firstclick-center">
                                                                                                <div
                                                                                                    ref={exportImageRef}
                                                                                                    className={`${behaviorType === "image"
                                                                                                        ? "w-100 text-center"
                                                                                                        : "d-none"
                                                                                                        }`}
                                                                                                    style={{
                                                                                                        overflowX:
                                                                                                            activeScreenSize ===
                                                                                                                "Actual size"
                                                                                                                ? "auto"
                                                                                                                : "hidden",
                                                                                                    }}
                                                                                                >
                                                                                                    {items.is_placeholder ==
                                                                                                        "no" && (
                                                                                                            <img
                                                                                                                src={`${process.env.REACT_APP_IMG_URL.replace(
                                                                                                                    /\/+$/,
                                                                                                                    ""
                                                                                                                )}/${items.img.replace(
                                                                                                                    /^\/+/,
                                                                                                                    ""
                                                                                                                )}`}
                                                                                                                style={{
                                                                                                                    maxWidth:
                                                                                                                        activeScreenSize ===
                                                                                                                            "Actual size"
                                                                                                                            ? "unset"
                                                                                                                            : "100%",
                                                                                                                    display: "table",
                                                                                                                    margin: "0 auto",
                                                                                                                    maxHeight:
                                                                                                                        activeScreenSize ===
                                                                                                                            "Fit to canvas"
                                                                                                                            ? "600px"
                                                                                                                            : "unset",
                                                                                                                }}
                                                                                                            />
                                                                                                        )}
                                                                                                    {items.is_placeholder ==
                                                                                                        "yes" && (
                                                                                                            <div className="path-preview-not-available">
                                                                                                                <div className="path-preview-not-available-inner">
                                                                                                                    <Icon
                                                                                                                        value={"error"}
                                                                                                                        size={"large"}
                                                                                                                    />
                                                                                                                    <Text
                                                                                                                        type={"subtitle-1"}
                                                                                                                        fontWeight={
                                                                                                                            "medium-font"
                                                                                                                        }
                                                                                                                    >
                                                                                                                        Preview not available
                                                                                                                    </Text>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                </div>
                                                                                                <div
                                                                                                    className={`w-100 ${activeScreenWidth <= 1300
                                                                                                        ? "flex-center"
                                                                                                        : ""
                                                                                                        }`}
                                                                                                >
                                                                                                    <div
                                                                                                        ref={exportHeatmapRef}
                                                                                                        className={`heatmapImage ${behaviorType === "heatmap"
                                                                                                            ? ""
                                                                                                            : "d-none"
                                                                                                            }`}
                                                                                                        style={{
                                                                                                            width: "0px",
                                                                                                            height: "0px",
                                                                                                            overflow: "hidden",
                                                                                                            position: "absolute",
                                                                                                            visibility: "hidden",
                                                                                                        }}
                                                                                                    >
                                                                                                        {items.is_placeholder ==
                                                                                                            "no" && (
                                                                                                                <img
                                                                                                                    ref={imageHeatmapRef}
                                                                                                                    id="imageid"
                                                                                                                    src={`${process.env.REACT_APP_IMG_URL.replace(
                                                                                                                        /\/+$/,
                                                                                                                        ""
                                                                                                                    )}/${items.img.replace(
                                                                                                                        /^\/+/,
                                                                                                                        ""
                                                                                                                    )}`}
                                                                                                                />
                                                                                                            )}
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div
                                                                                                    className={`w-100 ${activeScreenWidth <= 1300
                                                                                                        ? "flex-center"
                                                                                                        : ""
                                                                                                        }`}
                                                                                                >
                                                                                                    <div
                                                                                                        ref={exportClickmapRef}
                                                                                                        className={`clickMapImage position-relative ${behaviorType === "clickmap"
                                                                                                            ? ""
                                                                                                            : "d-none"
                                                                                                            }`}
                                                                                                        style={{
                                                                                                            width: "0px",
                                                                                                            height: "0px",
                                                                                                            overflow: "hidden",
                                                                                                            position: "absolute",
                                                                                                            visibility: "hidden",
                                                                                                        }}
                                                                                                    >
                                                                                                        {items.is_placeholder ==
                                                                                                            "no" && (
                                                                                                                <img
                                                                                                                    ref={imageClickmapRef}
                                                                                                                    src={`${process.env.REACT_APP_IMG_URL.replace(
                                                                                                                        /\/+$/,
                                                                                                                        ""
                                                                                                                    )}/${items.img.replace(
                                                                                                                        /^\/+/,
                                                                                                                        ""
                                                                                                                    )}`}
                                                                                                                />
                                                                                                            )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>

                                                                                            {heatmapImageLoading &&
                                                                                                behaviorType !== "image" ? (
                                                                                                <div className="page-loader accountloading-box result-sections-loader">
                                                                                                    <LoadingIcon />
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div
                                                                                                    className={
                                                                                                        "heatmap-clickmap-canvas-wrapper"
                                                                                                    }
                                                                                                    id={
                                                                                                        "heatmap-clickmap-canvas-wrapper"
                                                                                                    }
                                                                                                    style={{
                                                                                                        overflowX:
                                                                                                            activeScreenSize ===
                                                                                                                "Actual size"
                                                                                                                ? "auto"
                                                                                                                : "hidden",
                                                                                                    }}
                                                                                                >
                                                                                                    {items.is_placeholder ==
                                                                                                        "no" && (
                                                                                                            <canvas
                                                                                                                ref={exportRef}
                                                                                                                className={`${behaviorType === "image"
                                                                                                                    ? "d-none"
                                                                                                                    : ""
                                                                                                                    }`}
                                                                                                                id="my-canvas"
                                                                                                                style={{
                                                                                                                    maxWidth:
                                                                                                                        activeScreenSize ===
                                                                                                                            "Actual size"
                                                                                                                            ? "unset"
                                                                                                                            : "100%",
                                                                                                                    display:
                                                                                                                        behaviorType == "image"
                                                                                                                            ? "d-none"
                                                                                                                            : "table",
                                                                                                                    margin: "0 auto",
                                                                                                                    maxHeight:
                                                                                                                        activeScreenSize ===
                                                                                                                            "Fit to canvas"
                                                                                                                            ? "600px"
                                                                                                                            : "unset",
                                                                                                                }}
                                                                                                                width={
                                                                                                                    activeScreenWidth
                                                                                                                        ? activeScreenWidth +
                                                                                                                        "px"
                                                                                                                        : "0"
                                                                                                                }
                                                                                                                height={
                                                                                                                    activeScreenHeight
                                                                                                                        ? activeScreenHeight +
                                                                                                                        "px"
                                                                                                                        : "0"
                                                                                                                }
                                                                                                            ></canvas>
                                                                                                        )}
                                                                                                    {items.is_placeholder ==
                                                                                                        "yes" &&
                                                                                                        behaviorType !== "image" && (
                                                                                                            <div className="path-preview-not-available">
                                                                                                                <div className="path-preview-not-available-inner">
                                                                                                                    <Icon
                                                                                                                        value={"error"}
                                                                                                                        size={"large"}
                                                                                                                    />
                                                                                                                    <Text
                                                                                                                        type={"subtitle-1"}
                                                                                                                        fontWeight={
                                                                                                                            "medium-font"
                                                                                                                        }
                                                                                                                    >
                                                                                                                        Preview not available
                                                                                                                    </Text>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                </div>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                            </React.Fragment>
                                                                        );
                                                                    }
                                                                )}
                                                        </div>

                                                        <div className="slider-time-bottom">
                                                            <div className="slide-count-info light-dark-text medium-font">
                                                                <Icon size={"medium"} value={"time"} />
                                                                Average time spent
                                                                <span>
                                                                    {averageTaskTime(
                                                                        activePrototypeDataArray.prototypeTaskResultsAverageTime
                                                                    )}
                                                                </span>
                                                            </div>

                                                            {activePrototypeDataArray.behaviourData &&
                                                                activePrototypeDataArray.behaviourData.map(
                                                                    (items, index) => {
                                                                        return (
                                                                            <React.Fragment
                                                                                key={
                                                                                    items.node_id ||
                                                                                    `behaviour-click-${index}`
                                                                                }
                                                                            >
                                                                                {items.node_id ===
                                                                                    activeScreenOption && (
                                                                                        <div className="slide-count-info light-dark-text medium-font">
                                                                                            <Icon
                                                                                                size={"medium"}
                                                                                                value={"click"}
                                                                                            />
                                                                                            Average clicks
                                                                                            <span>
                                                                                                {Math.ceil(
                                                                                                    items.averageClickNode
                                                                                                )}
                                                                                            </span>
                                                                                        </div>
                                                                                    )}
                                                                            </React.Fragment>
                                                                        );
                                                                    }
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Screen Recording Start */}
                                        <div className={`question-result-data ${activeTaskMenu !== "screen-recordings" ? "d-none" : ""}`} id={"screen-recordings"}>
                                            <div className="prototype-result-overview-wrap">
                                                <div className={`prototype-screen-recordings`}>
                                                    <div>
                                                        <div className={`prototype-table-content `}>
                                                            <ScreenRecordingTable
                                                                screenRecordingData={screenRecordingData}
                                                                showVideo={handleVideoModal}
                                                                sortData={handleSort}
                                                                loadMore={handlePagination}
                                                                loadMoreLoading={loadingMore}
                                                                moreDataAvailable={moreDataAvailable}
                                                                filterOs={filterOs}
                                                                filterPath={filterPath}
                                                                updateFilterOs={handleFilterOs}
                                                                updateFilterPath={handleFilterPath}
                                                                test={test}
                                                                loadingData={isFetchingData}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`prototype-followup-section ${activeTaskMenu == "screen-recordings" ? "d-none" : ""}`}>
                                        <Text cssClasses={"pt-5"} type={"h4"}>
                                            {taskSetting && taskSetting.objective === "closed"
                                                ? "Follow up question"
                                                : "Questions"}
                                        </Text>
                                        {taskArray[isActiveTask] && (
                                            <PrototypeTestFollowupQuestionsResult
                                                resultData={taskArray[isActiveTask]["results_data"]}
                                                resultCount={resultCount}
                                                settingType={
                                                    taskSetting && taskSetting.objective === "closed"
                                                        ? "closed"
                                                        : "open"
                                                }
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {!sectionLoading && resultCount === 0 && (
                                <div className={`no-participants-data no-questions-data`}>
                                    <div className="no-page-data-wrap" style={{ marginTop: "80px" }}>
                                        <div className="no-data-icon">
                                            <Icon
                                                value={"Attention"}
                                                colorClass={"gray-700-svg"}
                                                size={"large"}
                                            />
                                        </div>
                                        <Text type={"subtitle-1"} fontWeight="medium-font">
                                            Details are not available at the moment as the test didn’t
                                            receive any response yet. Please come back later.
                                        </Text>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {!isSharedLink && (
                <a
                    onClick={(e) => {
                        e.preventDefault();

                        setShowSupportPanel(true);
                    }}
                    href={process.env.REACT_APP_URL + "r/support"}
                    target="_blank"
                    className="support-button"
                    rel="noreferrer"
                >
                    <Icon value={"support"} colorClass={"gray-50-svg"} size={"medium"} />
                    Support
                </a>
            )}

            <Preview
                withMinimizeIcon={true}
                open={previewModal.open}
                loading={false}
                img={previewModal.img}
                close={() => {
                    setPreviewModal({ open: false, img: null, loading: false });
                }}
            />
            <BaseModal
                heading={
                    <>
                        <Text type={"h3"} cssClasses={"mr-32"}>
                            {modalData.tester_type}
                        </Text>
                        <div className="d-flex  mob-absolute">
                            <div className="d-flex align-items-center mr-24">
                                <span className="mr-8">
                                    <Icon
                                        value={"time"}
                                        colorClass={"gray-700-svg "}
                                        size={"medium"}
                                    />{" "}
                                </span>
                                <Text
                                    type={"body-text-3"}
                                    cssClasses={"gray-text"}
                                    fontWeight={"medium-font"}
                                >
                                    {calculateTime(modalData.time_spent)}
                                </Text>
                            </div>
                            <div className="d-flex align-items-center mr-24">
                                <span className="mr-8">
                                    <Icon
                                        value={"click"}
                                        colorClass={"gray-700-svg "}
                                        size={"medium"}
                                    />{" "}
                                </span>
                                <Text
                                    type={"body-text-3"}
                                    cssClasses={"gray-text"}
                                    fontWeight={"medium-font"}
                                >
                                    {modalData.clicks_count} clicks
                                </Text>
                            </div>
                        </div>
                    </>
                }
                body={
                    videoModal.isloading ? (
                        <div className="welcome-loader-inner" id="video-modal-loader">
                            <LoadingIcon />
                        </div>
                    ) : (
                        <VideoPlayer src={activeVideoUrl} />
                    )
                }
                open={videoModal.open}
                close={() => {
                    setVideoModal({ ...videoModal, open: false });
                }}
                cssClass={"video-modal"}
            />
        </LayoutResearcher>
    );
}
